module.exports = __webpack_public_path__ + "assets/img/travel-details-spot.577787bb.png";